<template>
  <b-modal id="modal-edit-editor" @ok="save_block_edit" hide-header ok-title="Save">

    <div v-if="editing_block.type === 'hero'">
      <b-form-group label="Header" label-cols="4">
        <b-input v-model="editing_content.header"></b-input>
      </b-form-group>

      <b-form-group label="Sub heading" label-cols="4">
        <b-input v-model="editing_content.sub_heading"></b-input>
      </b-form-group>

      <b-form-group label="Left align" label-cols="4">
        <b-form-checkbox v-model="editing_content.image_side"></b-form-checkbox>
      </b-form-group>

      <b-form-group label="Image" label-cols="4">
        <div v-if="editing_content.image">
          <img height="48" :src="editing_content.image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('image', url)" />
      </b-form-group>

      <b-form-group label="Background image" label-cols="4">
        <div v-if="editing_content.background_image">
          <img height="48" :src="editing_content.background_image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.background_image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('background_image', url)" />
      </b-form-group>

      <b-form-group label="Background colour" label-cols="4">
        <b-button v-if="editing_content.background_colour" @click="editing_content.background_colour = null" variant="danger">Reset colour</b-button>
        <b-form-input v-else type="color" @change="(val) => {editing_content.background_colour = val}" style="display: inline-block; width: 40px;"/>
      </b-form-group>

      <b-form-group label="Text colour" label-cols="4">
        <b-form-select v-model="editing_content.text_color" :options="['dark', 'light']"></b-form-select>
      </b-form-group>

      <h3>Call to action</h3>
      <b-form-group label="Action" label-cols="4">
        <b-input v-model="editing_content.action"></b-input>
      </b-form-group>

      <b-form-group label="Link" label-cols="4">
        <b-input v-model="editing_content.link"></b-input>
      </b-form-group>
    </div>

    <div v-if="editing_block.type === 'awards'">
      <b-form-group label="Header" label-cols="4">
        <b-input v-model="editing_content.header"></b-input>
      </b-form-group>

      <b-form-group label="Sub heading" label-cols="4">
        <b-input v-model="editing_content.sub_heading"></b-input>
      </b-form-group>

      <b-form-group label="Awards" label-cols="4">
        <b-form-select v-model="editing_content._awards" :options="awards" multiple></b-form-select>
      </b-form-group>

      <b-form-group label="Background image" label-cols="4">
        <div v-if="editing_content.background_image">
          <img height="48" :src="editing_content.background_image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.background_image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('background_image', url)" />
      </b-form-group>

      <b-form-group label="Background colour" label-cols="4">
        <b-button v-if="editing_content.background_colour" @click="editing_content.background_colour = null" variant="danger">Reset colour</b-button>
        <b-form-input v-else type="color" @change="(val) => {editing_content.background_colour = val}" style="display: inline-block; width: 40px;"/>
      </b-form-group>

      <b-form-group label="Text colour" label-cols="4">
        <b-form-select v-model="editing_content.text_color" :options="['dark', 'light']"></b-form-select>
      </b-form-group>
    </div>

    <div v-if="editing_block.type === 'blogs'">
      <b-form-group label="Header" label-cols="4">
        <b-input v-model="editing_content.header"></b-input>
      </b-form-group>

      <b-form-group label="Sub heading" label-cols="4">
        <b-input v-model="editing_content.sub_heading"></b-input>
      </b-form-group>

      <b-form-group label="Blogs" label-cols="4">
        <b-form-select v-model="editing_content._blogs" :options="blogs" multiple></b-form-select>
      </b-form-group>

      <b-form-group label="Background image" label-cols="4">
        <div v-if="editing_content.background_image">
          <img height="48" :src="editing_content.background_image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.background_image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('background_image', url)" />
      </b-form-group>

      <b-form-group label="Background colour" label-cols="4">
        <b-button v-if="editing_content.background_colour" @click="editing_content.background_colour = null" variant="danger">Reset colour</b-button>
        <b-form-input v-else type="color" @change="(val) => {editing_content.background_colour = val}" style="display: inline-block; width: 40px;"/>
      </b-form-group>

      <b-form-group label="Text colour" label-cols="4">
        <b-form-select v-model="editing_content.text_color" :options="['dark', 'light']"></b-form-select>
      </b-form-group>
    </div>

    <div v-if="editing_block.type === 'testimonials'">
      <b-form-group label="Header" label-cols="4">
        <b-input v-model="editing_content.header"></b-input>
      </b-form-group>

      <b-form-group label="Sub heading" label-cols="4">
        <b-input v-model="editing_content.sub_heading"></b-input>
      </b-form-group>

      <b-form-group label="testimonials" label-cols="4">
        <b-form-select v-model="editing_content._testimonials" :options="testimonials" multiple></b-form-select>
      </b-form-group>

      <b-form-group label="Background image" label-cols="4">
        <div v-if="editing_content.background_image">
          <img height="48" :src="editing_content.background_image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.background_image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('background_image', url)" />
      </b-form-group>

      <b-form-group label="Background colour" label-cols="4">
        <b-button v-if="editing_content.background_colour" @click="editing_content.background_colour = null" variant="danger">Reset colour</b-button>
        <b-form-input v-else type="color" @change="(val) => {editing_content.background_colour = val}" style="display: inline-block; width: 40px;"/>
      </b-form-group>

      <b-form-group label="Text colour" label-cols="4">
        <b-form-select v-model="editing_content.text_color" :options="['dark', 'light']"></b-form-select>
      </b-form-group>
    </div>

    <div v-if="editing_block.type === 'services'">
      <b-form-group label="Header" label-cols="4">
        <b-input v-model="editing_content.header"></b-input>
      </b-form-group>

      <b-form-group label="Sub heading" label-cols="4">
        <b-input v-model="editing_content.sub_heading"></b-input>
      </b-form-group>

      <b-form-group label="services" label-cols="4">
        <b-form-select v-model="editing_content._services" :options="services" multiple></b-form-select>
      </b-form-group>

      <b-form-group label="Background image" label-cols="4">
        <div v-if="editing_content.background_image">
          <img height="48" :src="editing_content.background_image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.background_image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('background_image', url)" />
      </b-form-group>

      <b-form-group label="Background colour" label-cols="4">
        <b-button v-if="editing_content.background_colour" @click="editing_content.background_colour = null" variant="danger">Reset colour</b-button>
        <b-form-input v-else type="color" @change="(val) => {editing_content.background_colour = val}" style="display: inline-block; width: 40px;"/>
      </b-form-group>

      <b-form-group label="Text colour" label-cols="4">
        <b-form-select v-model="editing_content.text_color" :options="['dark', 'light']"></b-form-select>
      </b-form-group>
    </div>

    <div v-if="editing_block.type === 'form'">
      <b-form-group label="form" label-cols="4">
        <b-form-select v-model="editing_content._form" :options="forms"></b-form-select>
      </b-form-group>

      <b-form-group label="Background image" label-cols="4">
        <div v-if="editing_content.background_image">
          <img height="48" :src="editing_content.background_image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.background_image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('background_image', url)" />
      </b-form-group>

      <b-form-group label="Background colour" label-cols="4">
        <b-button v-if="editing_content.background_colour" @click="editing_content.background_colour = null" variant="danger">Reset colour</b-button>
        <b-form-input v-else type="color" @change="(val) => {editing_content.background_colour = val}" style="display: inline-block; width: 40px;"/>
      </b-form-group>

      <b-form-group label="Text colour" label-cols="4">
        <b-form-select v-model="editing_content.text_color" :options="['dark', 'light']"></b-form-select>
      </b-form-group>
    </div>

    <div v-if="editing_block.type === 'article'">

      <div class="editor">
        <editor-menu-bubble :editor="editor" v-slot="{ commands, isActive, menu }">
          <div class="menububble" :class="{ 'is-active': menu.isActive }" :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`">
            <button class="menubar__button font-weight-bold" :class="{ 'is-active': isActive.bold() }" @click="commands.bold">B</button>
            <button class="menubar__button font-italic" :class="{ 'is-active': isActive.italic() }" @click="commands.italic">I</button>
          </div>
        </editor-menu-bubble>

        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
          <div class="menubar">
            <button class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 2 }) }" @click="commands.heading({ level: 2 })">H2</button>
            <button class="menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click="commands.heading({ level: 3 })">H3</button>
            <ImageSearch classProp="menubar__button" :type="['upload', 'image']" :action="add_image.bind(null, commands.image)" />
          </div>
        </editor-menu-bar>

        <editor-content class="editor__content" :editor="editor" />
      </div>
    </div>

    <div v-if="editing_block.type === 'faqs'">
      <b-form-group label="Header" label-cols="4">
        <b-input v-model="editing_content.header"></b-input>
      </b-form-group>

      <b-form-group label="Sub heading" label-cols="4">
        <b-input v-model="editing_content.sub_heading"></b-input>
      </b-form-group>

      <draggable v-model="editing_content.faqs" handle=".handle">
        <transition-group>
          <b-row v-for="(faq, $index) in editing_content.faqs" :key="'FAQ' + $index" no-gutters>
            <b-card no-body class="mb-2 w-100">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button v-b-toggle="`accordion-${$index}`" variant="transparent">{{faq.question}}</b-button>
                <b-button class="handle float-right"><i class="fas fa-grip-vertical"></i></b-button>
              </b-card-header>
              <b-collapse :id="`accordion-${$index}`" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-form-group label="Question">
                    <b-input size="sm" v-model="faq.question"></b-input>
                  </b-form-group>
                  <b-form-group label="Answer">
                    <b-form-textarea size="sm" v-model="faq.answer"></b-form-textarea>
                  </b-form-group>
                  <b-button variant="danger" size="sm" @click="editing_content.faqs.splice($index, 1)">Delete</b-button>
                </b-card-body>
              </b-collapse>
            </b-card>
          </b-row>
        </transition-group>
      </draggable>

      <b-button variant="secondary" @click="editing_content.faqs.push({question: 'Question', answer: 'Answer'})">Add FAQ</b-button>

      <b-form-group label="Background image" label-cols="4">
        <div v-if="editing_content.background_image">
          <img height="48" :src="editing_content.background_image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.background_image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('background_image', url)" />
      </b-form-group>

      <b-form-group label="Background colour" label-cols="4">
        <b-button v-if="editing_content.background_colour" @click="editing_content.background_colour = null" variant="danger">Reset colour</b-button>
        <b-form-input v-else type="color" @change="(val) => {editing_content.background_colour = val}" style="display: inline-block; width: 40px;"/>
      </b-form-group>

      <b-form-group label="Text colour" label-cols="4">
        <b-form-select v-model="editing_content.text_color" :options="['dark', 'light']"></b-form-select>
      </b-form-group>
    </div>

    <div v-if="editing_block.type === 'checklist'">
      <b-form-group label="Header" label-cols="4">
        <b-input v-model="editing_content.header"></b-input>
      </b-form-group>

      <b-form-group label="Sub heading" label-cols="4">
        <b-input v-model="editing_content.sub_heading"></b-input>
      </b-form-group>

      <draggable v-model="editing_content.checklist" handle=".handle">
        <transition-group>
          <b-row v-for="(item, $index) in editing_content.checklist" :key="'Checklist' + $index" no-gutters>
            <b-card no-body class="mb-2 w-100">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button v-b-toggle="`accordion-${$index}`" variant="transparent">{{item.item}}</b-button>
                <b-button class="handle float-right"><i class="fas fa-grip-vertical"></i></b-button>
              </b-card-header>
              <b-collapse :id="`accordion-${$index}`" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-form-group label="Item">
                    <b-input size="sm" v-model="item.item"></b-input>
                  </b-form-group>
                  <b-button variant="danger" size="sm" @click="editing_content.checklist.splice($index, 1)">Delete</b-button>
                </b-card-body>
              </b-collapse>
            </b-card>
          </b-row>
        </transition-group>
      </draggable>

      <b-button variant="secondary" @click="editing_content.checklist.push({item: 'Item'})">Add Item</b-button>

      <b-form-group label="Background image" label-cols="4">
        <div v-if="editing_content.background_image">
          <img height="48" :src="editing_content.background_image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.background_image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('background_image', url)" />
      </b-form-group>

      <b-form-group label="Background colour" label-cols="4">
        <b-button v-if="editing_content.background_colour" @click="editing_content.background_colour = null" variant="danger">Reset colour</b-button>
        <b-form-input v-else type="color" @change="(val) => {editing_content.background_colour = val}" style="display: inline-block; width: 40px;"/>
      </b-form-group>

      <b-form-group label="Text colour" label-cols="4">
        <b-form-select v-model="editing_content.text_color" :options="['dark', 'light']"></b-form-select>
      </b-form-group>
    </div>

    <div v-if="editing_block.type === 'features'">
      <b-form-group label="Header" label-cols="4">
        <b-input v-model="editing_content.header"></b-input>
      </b-form-group>

      <b-form-group label="Sub heading" label-cols="4">
        <b-input v-model="editing_content.sub_heading"></b-input>
      </b-form-group>

      <draggable v-model="editing_content.features" handle=".handle">
        <transition-group>
          <b-row v-for="(feature, $index) in editing_content.features" :key="'features' + $index" no-gutters>
            <b-card no-body class="mb-2 w-100">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button v-b-toggle="`accordion-${$index}`" variant="transparent">{{feature.header}} <i class="fas fa-chevron-down"></i></b-button>
                <b-button class="handle float-right"><i class="fas fa-grip-vertical"></i></b-button>
              </b-card-header>
              <b-collapse :id="`accordion-${$index}`" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <!-- <b-form-group label="Icon">
                    <b-button v-if="feature.icon" variant="danger" @click="feature.icon = null">Remove icon</b-button>
                    <ImageSearch v-else :type="['fa_icon']" classProp="btn btn-secondary" :action="url => {feature.icon = url}" :is_small="true"/>
                  </b-form-group> -->

                  <b-form-group label="Icon">
                    <div v-if="feature.icon">
                      <img height="48" :src="feature.icon" class="mr-2"/>
                      <b-button variant="danger" @click="feature.icon = null">Clear</b-button>
                    </div>
                    <ImageSearch v-else :type="['fa_icon']" classProp="btn btn-secondary" :action="url => update_editing_content('icon', url, feature)" :is_small="true"/>
                  </b-form-group>

                  <b-form-group label="Header">
                    <b-input size="sm" v-model="feature.header"></b-input>
                  </b-form-group>
                  <b-form-group label="Description">
                    <b-form-textarea size="sm" v-model="feature.description"></b-form-textarea>
                  </b-form-group>
                  <b-button variant="danger" size="sm" @click="editing_content.features.splice($index, 1)">Delete</b-button>
                </b-card-body>
              </b-collapse>
            </b-card>
          </b-row>
        </transition-group>
      </draggable>

      <b-button variant="secondary" @click="editing_content.features.push({header: 'Feature', description: 'Description...'})">Add Features</b-button>

      <b-form-group label="Background image" label-cols="4">
        <div v-if="editing_content.background_image">
          <img height="48" :src="editing_content.background_image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.background_image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('background_image', url)" />
      </b-form-group>

      <b-form-group label="Background colour" label-cols="4">
        <b-button v-if="editing_content.background_colour" @click="editing_content.background_colour = null" variant="danger">Reset colour</b-button>
        <b-form-input v-else type="color" @change="(val) => {editing_content.background_colour = val}" style="display: inline-block; width: 40px;"/>
      </b-form-group>

      <b-form-group label="Text colour" label-cols="4">
        <b-form-select v-model="editing_content.text_color" :options="['dark', 'light']"></b-form-select>
      </b-form-group>
    </div>

    <div v-if="editing_block.type === 'cta'">
      <b-form-group label="Header" label-cols="4">
        <b-input v-model="editing_content.header"></b-input>
      </b-form-group>

      <b-form-group label="Sub heading" label-cols="4">
        <b-input v-model="editing_content.sub_heading"></b-input>
      </b-form-group>

      <b-form-group label="Action" label-cols="4">
        <b-input v-model="editing_content.action"></b-input>
      </b-form-group>

      <b-form-group label="Link" label-cols="4">
        <b-input v-model="editing_content.link"></b-input>
      </b-form-group>

      <b-form-group label="Left align" label-cols="4">
        <b-form-checkbox v-model="editing_content.image_side"></b-form-checkbox>
      </b-form-group>

      <b-form-group label="Image" label-cols="4">
        <div v-if="editing_content.image">
          <img height="48" :src="editing_content.image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('image', url)" />
      </b-form-group>

      <b-form-group label="Background image" label-cols="4">
        <div v-if="editing_content.background_image">
          <img height="48" :src="editing_content.background_image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.background_image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('background_image', url)" />
      </b-form-group>

      <b-form-group label="Background colour" label-cols="4">
        <b-button v-if="editing_content.background_colour" @click="editing_content.background_colour = null" variant="danger">Reset colour</b-button>
        <b-form-input v-else type="color" @change="(val) => {editing_content.background_colour = val}" style="display: inline-block; width: 40px;"/>
      </b-form-group>

      <b-form-group label="Text colour" label-cols="4">
        <b-form-select v-model="editing_content.text_color" :options="['dark', 'light']"></b-form-select>
      </b-form-group>
    </div>

    <div v-if="editing_block.type === 'text'">
      <b-form-group label="Header" label-cols="4">
        <b-input v-model="editing_content.header"></b-input>
      </b-form-group>

      <b-form-group label="Sub heading" label-cols="4">
        <b-input v-model="editing_content.sub_heading"></b-input>
      </b-form-group>

      <b-form-group label="Text" label-cols="4">
        <b-form-textarea v-model="editing_content.text" rows="4"></b-form-textarea>
      </b-form-group>

      <b-form-group label="Left align" label-cols="4">
        <b-form-checkbox v-model="editing_content.image_side"></b-form-checkbox>
      </b-form-group>

      <b-form-group label="Image" label-cols="4">
        <div v-if="editing_content.image">
          <img height="48" :src="editing_content.image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('image', url)" />
      </b-form-group>

      <b-form-group label="Background image" label-cols="4">
        <div v-if="editing_content.background_image">
          <img height="48" :src="editing_content.background_image" class="mr-2"/>
          <b-button variant="danger" @click="editing_content.background_image = null">Clear</b-button>
        </div>
        <ImageSearch v-else :type="['upload', 'image']" classProp="btn btn-secondary" :action="url => update_editing_content('background_image', url)" />
      </b-form-group>

      <b-form-group label="Background colour" label-cols="4">
        <b-button v-if="editing_content.background_colour" @click="editing_content.background_colour = null" variant="danger">Reset colour</b-button>
        <b-form-input v-else type="color" @change="(val) => {editing_content.background_colour = val}" style="display: inline-block; width: 40px;"/>
      </b-form-group>

      <b-form-group label="Text colour" label-cols="4">
        <b-form-select v-model="editing_content.text_color" :options="['dark', 'light']"></b-form-select>
      </b-form-group>
    </div>

    <template v-slot:modal-footer="{ ok, cancel }">
      <div class="w-100">
        <b-button size="sm" @click="delete_block" variant="danger" v-if="can_add_blocks && editing_block.type !== 'hero'">Delete</b-button>
        <b-button size="sm" @click="move_block('up')" v-if="can_add_blocks && editing_block.type !== 'hero'"><i class="fas fa-arrow-up"></i></b-button>
        <b-button size="sm" @click="move_block('down')" v-if="can_add_blocks && editing_block.type !== 'hero'"><i class="fas fa-arrow-down"></i></b-button>
        <b-button class="float-right ml-2" size="sm" variant="primary" @click="ok()">OK</b-button>
        <b-button class="float-right" size="sm" @click="cancel()">Cancel</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>

import {db, storage, serverTimestamp, FieldValue} from '@/main.js'
import draggable from 'vuedraggable'
import ImageSearch from '@/components/ImageSearch'

import {required, minLength} from "vuelidate/lib/validators"
import {Editor, EditorContent, EditorFloatingMenu, EditorMenuBubble, EditorMenuBar} from 'tiptap'
import {Blockquote, BulletList, HardBreak, Heading, ListItem, OrderedList, Bold, Italic, Link, History, Placeholder, Image} from 'tiptap-extensions'

import Doc from '@/components/Doc.js'
import DragDropImage from '@/components/Image.js'

export default {
  props: ['entry', 'site', 'entries', 'editing_content', 'editing_block'],
  components: {ImageSearch, draggable, EditorContent, EditorMenuBubble, EditorMenuBar},
  data() {
    return {
      editor: null,
      new_entity: {}
    }
  },
  watch: {
    editing_content: function(val) {
      if (this.editing_block.type === 'article') {
        if (!this.editor) {
          this.editor = new Editor({
            autoFocus: true,
            onUpdate: this.update_content,
            extensions: [
              new Blockquote(), new BulletList(), new HardBreak(), new Heading({levels: [2, 3]}), new ListItem(),
              new OrderedList(), new Link(), new Bold(), new Italic(), new History(),
              new DragDropImage(null, null, this.upload),
              new Image()
            ],
          })
        }

        this.editor.setContent(`${this.editing_content.text}`)
      }
    }
  },
  computed: {
    can_add_blocks() {
      if (this.entry.page.template) {
        return false
      } else {
        return true
      }
    },
    services() {
      let services = []
      for (let entry of this.entries) {
        if (!entry.template && entry.collection === 'services') {
          services.push({value: entry.id, text: entry.name})
        }
      }

      return services
    },
    forms() {
      let forms = []
      for (let entry of this.entries) {
        if (!entry.template && entry.collection === 'forms') {
          forms.push({value: entry.id, text: entry.name})
        }
      }

      return forms
    },
    awards() {
      let awards = []
      for (let entry of this.entries) {
        if (!entry.template && entry.collection === 'awards') {
          awards.push({value: entry.id, text: entry.name})
        }
      }

      return awards
    },
    blogs() {
      let blogs = []
      for (let entry of this.entries) {
        if (!entry.template && entry.collection === 'blogs') {
          blogs.push({value: entry.id, text: entry.name})
        }
      }

      return blogs
    },
    testimonials() {
      let testimonials = []
      for (let entry of this.entries) {
        if (!entry.template && entry.collection === 'testimonials') {
          testimonials.push({value: entry.id, text: entry.name})
        }
      }

      return testimonials
    },
  },
  methods: {
    // TODO
    // async add_award() {
    //   // 'awards': {name: 'awards', entries: [], template: undefined, types: ['block'], fields: [
    //   //   {name: 'image', key: 'image', type: 'input', help_text: 'Help text'},
    //   //   {name: 'link', key: 'link', type: 'input', help_text: 'Help text'},
    //   // ]},
    //
    //   let item = {
    //     created: new Date(),
    //     updated: new Date(),
    //     name: `New Award`,
    //     template: false,
    //     types: ['block'],
    //     collection: 'awards',
    //     block: {
    //       content: {} // TODO
    //     },
    //     page: null,
    //     user: this.profile.id
    //   }
    //
    //   this.is_creating = true
    //   let item_doc = db.collection('site').doc(this.$route.params.site_id).collection('entry').doc()
    //   await item_doc.set(item)
    //   this.is_creating = false
    // },
    update_editing_content(key, value, context) {
      if (context) {
        context[key] = value
      } else {
        this.editing_content[key] = value
      }

      this.$forceUpdate()
    },
    async move_block(direction) {
      let current_index
      for (let i in this.entry.page.blocks) {
        if (this.entry.page.blocks[i].id === this.editing_content.id) {
          current_index = i
          break
        }
      }

      let new_index

      if (direction === 'down') {
        if (current_index < this.entry.page.blocks.length-1) {
          new_index = parseInt(current_index) + 1
        } else {
          return
        }
      } else {
        if (current_index > 0) {
          new_index = parseInt(current_index) - 1
        } else {
          return
        }
      }

      this.entry.page.blocks.splice(new_index, 0, this.entry.page.blocks.splice(current_index, 1)[0])

      await db.collection('site').doc(this.$route.params.site_id).collection('entry').doc(this.$route.params.id).update({
        'page.blocks': this.entry.page.blocks,
      })

      await db.collection('deploy_queue').doc(this.site.id).set({updated: serverTimestamp(), update_count: FieldValue.increment(1)}, {merge: true})
    },
    async delete_block() {
      let result = await this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      })

      if (!result.value) {
        return
      }

      let block_index = -1
      for (let i in this.entry.page.blocks) {
        if (this.entry.page.blocks[i].id === this.editing_content.id) {
          block_index = i
          break
        }
      }

      if (block_index === -1) {
        throw new Error('Could not find block')
      }

      this.$bvModal.hide(`modal-edit-editor`)

      this.entry.page.blocks.splice(block_index, 1)
      delete this.entry.page.blocks_content[this.editing_content.id]

      await db.collection('site').doc(this.$route.params.site_id).collection('entry').doc(this.$route.params.id).update({
        'page.blocks': this.entry.page.blocks,
        'page.blocks_content': this.entry.page.blocks_content
      })

      await db.collection('deploy_queue').doc(this.site.id).set({updated: serverTimestamp(), update_count: FieldValue.increment(1)}, {merge: true})
    },
    get_all_entry_block(key) {
      let entries = []
      for (let entry of this.entries) {
        if (!entry.template && entry.collection === key) {
          entries.push(entry.block.content)
        }
      }

      return entries
    },
    async save_block_edit() {
      let update = {}

      update[`page.blocks_content.${this.editing_content.id}`] = this.editing_content
      this.entry.page.blocks_content[this.editing_content.id] = this.editing_content
      await db.collection('site').doc(this.$route.params.site_id).collection('entry').doc(this.$route.params.id).update(update)

      await db.collection('deploy_queue').doc(this.site.id).set({updated: serverTimestamp(), update_count: FieldValue.increment(1)}, {merge: true})
    },
    add_image(command, src) {
      if (src) {
        command({ src })
      }
    },
    async upload(file) {
      let id = db.collection('random').doc().id
      let snap = await storage.ref().child(`media/${id}`).put(file, {
        contentType: 'image/jpeg',
        'cacheControl': 'max-age=2628000, public'
      })
      return `https://storage.googleapis.com/${this.config.firebase_config.storageBucket}/media/${id}.png` // await snap.ref.getDownloadURL()
    },
    update_content(val) {
      // this.item.title = val.getHTML().split('</h1>')[0].split('<h1>')[1]
      this.editing_content.text = val.getHTML() || ''

      // if (val.getHTML().split('<img src="').length > 1) {
      //   this.item.preview_image = val.getHTML().split('<img src="')[1].split('">')[0]
      // }
      //
      // this.item.preview_text = val.getHTML().replace(/<[^>]*>?/gm, '')
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
    }
  },
}
</script>

<style lang="scss">
.editor {
    position: relative;
    &__floating-menu {
        position: absolute;
        z-index: 1;
        margin-top: -0.25rem;
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.2s, visibility 0.2s;
        &.is-active {
            opacity: 1;
            visibility: visible;
        }
    }
}

.menububble > .menubar__button {
    color: #FFF !important;
}

.editor__floating-menu > .menubar__button {
    opacity: 0.25;
}

.editor *.is-empty:nth-child(1)::before,
.editor *.is-empty:nth-child(2)::before {
    content: attr(data-empty-text);
    float: left;
    color: #aaa;
    pointer-events: none;
    height: 0;
    font-style: italic;
}

.cover {
  width: 100%;
}

</style>
